function registerRteAnimations() {
  // verify that the widget exists to avoid console errors.
  const instances = document.querySelectorAll('.animate-section')

  if (instances.length > 0) {
    instances.forEach(instance => {

      let rteWidgets = Array.from(instance.querySelectorAll('.fr-view'))
      console.log(rteWidgets)
      rteWidgets.forEach(widget => {
        let images = Array.from(widget.getElementsByTagName('img'))

        images.forEach(img => {
          img.classList.add('rte-animated');
        })
      })
    })
  }
}


document.addEventListener('DOMContentLoaded', (event) => {
  registerRteAnimations()
})
